import PreviousMeetingCard from './PreviousMeetingCard';
export default PreviousMeetingCard;